export default "__VITE_ASSET__613dc546__"